import { useContext, useMemo } from 'react'
import { classifyAudioInputs } from '../Logic'
import { UserContext, UserContextType } from '../UserContext'

export default function useMediaSourceViews() {
    const { state } = useContext(UserContext) as UserContextType

    const audioInputsClassifiedForUi = useMemo(() => {
        return classifyAudioInputs(state.mediaSources.audioInputs)
    }, [state.mediaSources.audioInputs])

    return {
        mediaSources: state.mediaSources,
        audioInputsClassifiedForUi,
    }
}
